import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { isKsDomain, isSjDomain } from 'utils/domain'
import informedAnimation from 'images/informed-animation.gif'
import { KS_HEADER_HEIGHT, SJ_HEADER_HEIGHT } from 'constants/size'

const headerSize = isKsDomain()
  ? KS_HEADER_HEIGHT
  : isSjDomain()
  ? SJ_HEADER_HEIGHT
  : 0
const IMAGE_RATIO = 1.78

/** 回転時のStyle設定  */
const setStyleFunc = (
  gifRef: React.RefObject<HTMLImageElement>,
  gifWrapperRef: React.RefObject<HTMLDivElement>,
  windowHeight: number
): void => {
  // アニメーションの親divのDOM要素
  const gifAnimeWrapper = gifWrapperRef.current
  // アニメーション自体のDOM要素
  const gifAnime = gifRef.current
  if (!gifAnime || !gifAnimeWrapper) return
  const animationW = gifAnimeWrapper.getBoundingClientRect().width
  const animationH = animationW / IMAGE_RATIO
  const dispAnimeArea = windowHeight - headerSize
  // アニメーションの高さ（横幅から算出）がスマホ画面の高さよりも大きいか
  if (dispAnimeArea < animationH) {
    // 左右に余白を作る
    gifAnime.style.height = `${dispAnimeArea}px`
    gifAnime.style.width = `${dispAnimeArea * IMAGE_RATIO}px`
    gifAnime.style.top = '0'
    gifAnimeWrapper.style.width = `${dispAnimeArea * IMAGE_RATIO}px`
  } else {
    // 上下に余白を作る
    const calcAreaSize = dispAnimeArea < 400 ? dispAnimeArea : 400
    gifAnime.style.height = `${animationH}px`
    gifAnime.style.width = `${animationW}px`
    gifAnime.style.top = `${(calcAreaSize - animationH) / 2}px`
    gifAnimeWrapper.style.width = '100vw'
  }
}

const InformedAnimation: React.FC<{}> = () => {
  // DOM要素取得
  const animationRef = useRef<HTMLImageElement>(null)
  const animationWraperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleResize = (): void => {
      setStyleFunc(animationRef, animationWraperRef, window.innerHeight)
    }
    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)
    // 初回マウント時にセット
    handleResize()
    // クリーンアップ
    return (): void => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [])

  return (
    <AnimationWrapper ref={animationWraperRef}>
      <StyledAnimation src={informedAnimation} ref={animationRef} />
    </AnimationWrapper>
  )
}

const AnimationWrapper = styled.div`
  height: 100%;
  width: 100vw;
  position: relative;
  max-width: 711px;
  min-width: 178px;
`

const StyledAnimation = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  max-height: 400px;
  min-height: 50px;
`

export default InformedAnimation
